import { Create } from "@/components/admin/create";
import { DataTable } from "@/components/admin/data-table";
import { Edit } from "@/components/admin/edit";
import { List } from "@/components/admin/list";
import { SimpleForm } from "@/components/admin/simple-form";
import { TextInput } from "@/components/admin/text-input";
import { withRBAC } from "./withRBAC";


export const PermissionsList = () => {
  return (
    <List title="Permissions" sort={{ field: "name", order: "ASC" }}>
      <DataTable rowClick="edit">
        <DataTable.Col source="slug" label="Permission Slug" />
        <DataTable.Col source="name" label="Display Name" />
        <DataTable.Col source="description" />
      </DataTable>
    </List>
  );
};

export const PermissionsCreate = () => (
  <Create title="Create Permission">
    <SimpleForm>
      <TextInput source="slug" required />
      <TextInput source="name" required />
      <TextInput source="description" multiline />
    </SimpleForm>
  </Create>
);

export const PermissionsEdit = () => (
  <Edit title="Edit Permission">
    <SimpleForm>
      <TextInput source="slug" required disabled />
      <TextInput source="name" required />
      <TextInput source="description" multiline />
    </SimpleForm>
  </Edit>
);

export const PermissionsPage = {
  list: withRBAC(PermissionsList, "manage_users"),
  create: withRBAC(PermissionsCreate, "manage_users"),
  edit: withRBAC(PermissionsEdit, "manage_users"),
};
